const colors = {
    primary: 'var(--color-primary)',
    primaryOpacity65: 'var(--color-primary-opacity-65)',
    black: '#000000',
    white: '#FFFFFF',
    gray1: 'var(--color-gray1)',
    gray2: 'var(--color-gray2)',
    gray3: 'var(--color-gray3)',
    gray4: 'var(--color-gray4)',
    gray5: 'var(--color-gray5)',
    gray6: 'var(--color-gray6)',
    gray7: 'var(--color-gray7)',
    gray8: 'var(--color-gray8)',
    gray9: 'var(--color-gray9)',
    buttonText: 'var(--color-button-text)',
    buttonDisabled: 'var(--color-button-disabled)',
    icon: 'var(--color-icon)',
    iconDefault: 'var(--color-icon-default)',
    iconUnselected: 'var(--color-icon-unselected)',
    iconError: 'var(--color-icon-error)',
    iconSuccess: 'var(--color-icon-success)',
    iconNotice: 'var(--color-icon-notice)',
    red: 'var(--color-red)',
    green: 'var(--color-green)',
    blue: 'var(--color-blue)',
    textPrimary: 'var(--color-text-primary)',
    textSecondary: 'var(--color-text-secondary)',
    textThird: 'var(--color-text-third)',
    textUnselected: 'var(--color-gray5)',
    textError: 'var(--color-text-error)',
    textReverse: 'var(--color-text-reverse)',
    textSuccess: 'var(--color-text-success)',
    surfaceDisabled: 'var(--color-gray2)',
};

export default colors;
